import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { BaseChartDirective } from 'ng2-charts';
import { PreviewTestDataComponent } from './preview-test-data/preview-test-data.component';
import { PreviewTestDataRoutingModule } from './preview-test-data-routing.module';
import { SampleInformationDialogComponent } from './sample-information-dialog/sample-information-dialog.component';
import { TemperaturesDialogComponent } from './temperatures-dialog/temperatures-dialog.component';
import { TestInformationDialogComponent } from './test-information-dialog/test-information-dialog.component';

@NgModule({
  declarations: [
    PreviewTestDataComponent,
    SampleInformationDialogComponent,
    TemperaturesDialogComponent,
    TestInformationDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PreviewTestDataRoutingModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatTableModule,
    BaseChartDirective,
  ],
})
export class PreviewTestDataModule { }
